module.exports = __webpack_public_path__ + "img/1521513418.66b379aa.jpg";